import { Box, styled } from '@mui/material';

import { forMobile } from '@/styles/responsive';

import { CustomButton } from '../custom-button';

export const ModalContent = styled(Box)(({ theme }) => ({
  position: 'fixed',
  maxWidth: 516,
  width: 'calc(100vw - 32px)',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#222833',
  padding: '24px',
  borderRadius: '16px',
  maxHeight: '680px',
  overflowY: 'auto',
  outline: 'none',

  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-button': {
    height: '20px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(67, 72, 91, 0.2)',
    borderRadius: '200px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  scrollbarGutter: 'stable',
  scrollbarWidth: 'thin',
  scrollbarColor: `rgba(67, 72, 91, 0.2) transparent`,

  [forMobile(theme)]: {
    top: 'auto',
    bottom: 0,
    left: 0,
    right: 0,
    transform: 'none',
    width: '100vw',
    maxWidth: '100%',
    maxHeight: '90vh',
    borderRadius: '16px 16px 0 0',
    padding: '40px 16px 20px',
  },
}));

export const CloseButton = styled(CustomButton)(({ theme }) => ({
  position: 'absolute',
  zIndex: 100,
  top: 20,
  right: 20,
  padding: 0,

  [forMobile(theme)]: {
    top: 12,
    right: 16,
  },
}));
